type ArrowIconProps = {
  fill?: string
  direction?: 'up' | 'down' | 'left' | 'right'
  id?: string
  type?: 'line' | 'solid'
  outline?: boolean
  width?: number
  height?: number
  className?: string
  strokeWidth?: number
}

export const ArrowIcon: React.FC<ArrowIconProps> = ({
  fill,
  direction = 'down',
  width,
  height,
  id,
  className,
  outline = true,
  type = 'line',
  strokeWidth = 1.5,
}) => {
  return (
    <div className={'ICON ' + className} id={id}>
      <svg
        width={width || '20'}
        height={height || width || '21'}
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          rotate:
            direction === 'up'
              ? '180deg'
              : direction === 'left'
                ? '90deg'
                : direction === 'right'
                  ? '-90deg'
                  : '0deg',
        }}
      >
        <defs>
          <mask id={`${id}-mask`}>
            <rect
              className={
                type === 'line'
                  ? 'invert transition-all duration-150 ease-in-out group-hover:invert-0'
                  : ''
              }
              width="20"
              height="21"
              fill={'white'}
            />
            <path
              className="VERTICAL-LINE"
              d="M10 5.10889V15.3042"
              stroke={'black'}
              strokeWidth={strokeWidth}
            />
            <path
              className="TRIANGLE-PART"
              d="M6.375 11.6792L10 15.3042L13.625 11.6792"
              stroke={'black'}
              strokeWidth={strokeWidth}
            />
          </mask>
        </defs>
        {type === 'line' && (
          <g clipPath="url(#clip0_12001_747)" className="group-hover:opacity-0">
            <path d="M10 5.10889V15.3042" stroke={fill || 'white'} strokeWidth={strokeWidth} />
            <path
              d="M6.375 11.6792L10 15.3042L13.625 11.6792"
              stroke={fill || 'white'}
              strokeWidth={strokeWidth}
            />

            <clipPath id="clip0_12001_747">
              <rect
                width="12"
                height="12"
                fill={fill || 'white'}
                transform="translate(4 4.54639)"
              />
            </clipPath>
          </g>
        )}
        <rect
          x="0.5"
          y="1.04639"
          width="19"
          height="19"
          rx="9.5"
          fill={type === 'solid' ? fill || 'white' : 'none'}
          mask={`url(#${id}-mask)`}
          className={
            `group-hover:fill-primary-dark transition-all duration-150 ease-in-out group-hover:stroke-white/0 ` +
            (outline ? 'border border-white' : '')
          }
        />
        {outline && (
          <rect
            x="0.5"
            y="1.04639"
            width="19"
            height="19"
            rx="9.5"
            stroke={fill}
            className={`transition-all duration-150 ease-in-out group-hover:opacity-0`}
          />
        )}
      </svg>
    </div>
  )
}
